import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-warning-incomplete-user-record',
    templateUrl: './incomplete-user-record.component.html',
    styleUrls: ['./incomplete-user-record.component.scss'],
})
export class IncompleteUserRecordComponent implements OnInit {
    missingFields: string[] = [];

    constructor(
        private router: Router,
        private dialogRef: MatDialogRef<IncompleteUserRecordComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { userRecord: any; requiredFields: string[] },
    ) {}

    ngOnInit() {
        this.data.requiredFields.forEach((field) => {
            if (!this.data.userRecord[field]) {
                this.missingFields.push(field);
            }
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
